import type { IconProps } from '../../types/icon-props';

export const EmptyItem = (props: IconProps) => {
  const { ...rest } = props;

  return (
    <svg width={161} height={177} viewBox="0 0 161 177" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <linearGradient x1="49.968%" y1="-2.316%" x2="49.968%" y2="101.076%" id="lcplbzp6jc">
          <stop offset="0%" stopColor="#FDFEFF" />
          <stop offset="99.64%" stopColor="#ECF0F5" />
        </linearGradient>
        <filter
          x="-62%"
          y="-79.3%"
          width="224%"
          height="324.4%"
          filterUnits="objectBoundingBox"
          id="fzvtjf416a"
        >
          <feOffset dy="17" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="16.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M112 68.511v40.74c0 5.63-4.533 10.134-10.302 10.134H28.763c-5.666 0-10.301-4.504-10.301-10.134V68.306c0-.204 0-.409.103-.614h23.487c3.503 0 6.387 2.764 6.387 6.347 0 1.74.721 3.378 1.854 4.504 1.237 1.228 2.679 1.842 4.533 1.842h20.912c3.503 0 6.387-2.764 6.387-6.346 0-1.74.721-3.378 1.855-4.504 1.236-1.229 2.678-1.843 4.43-1.843h23.384c.206.205.206.512.206.82z"
          id="j8xfmwz4gb"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M1 0h160v160H1z" />
        <path
          d="M80.63 142.277c34.462 0 62.4-27.939 62.4-62.523 0-34.585-28.06-62.523-62.4-62.523-34.46 0-62.4 27.938-62.4 62.523 0 34.584 27.94 62.523 62.4 62.523z"
          fill="#EAEEF9"
        />
        <path
          d="M126.538 75.438v37.285c0 7.746-6.284 14.046-14.113 14.046H47.113c-7.726 0-14.01-6.197-14.113-13.943V75.232c0-.207 0-.413.103-.62.103-.31.206-.516.31-.826l17.512-33.567c.618-1.342 1.957-2.065 3.4-2.065h50.786c1.442 0 2.679.723 3.4 2.065l17.512 33.567c.103.206.206.516.31.826.205.207.205.517.205.826z"
          fill="#D5DDEA"
        />
        <g transform="translate(14.538 7.385)">
          <use fill="#000" filter="url(#fzvtjf416a)" xlinkHref="#j8xfmwz4gb" />
          <use fill="url(#lcplbzp6jc)" xlinkHref="#j8xfmwz4gb" />
        </g>
        <path
          d="M144.385 49.23a4.31 4.31 0 0 0 4.307-4.307 4.31 4.31 0 0 0-4.307-4.308 4.31 4.31 0 0 0-4.308 4.308 4.31 4.31 0 0 0 4.308 4.308zM139.462 13.538a3.075 3.075 0 0 0 3.076-3.076 3.075 3.075 0 0 0-3.076-3.077 3.074 3.074 0 0 0-3.077 3.077 3.074 3.074 0 0 0 3.077 3.076zM18.846 50.462a3.075 3.075 0 0 0 3.077-3.077 3.075 3.075 0 0 0-3.077-3.077 3.074 3.074 0 0 0-3.077 3.077 3.074 3.074 0 0 0 3.077 3.077zM20.077 141.538a5.54 5.54 0 0 0 0-11.076 5.54 5.54 0 0 0 0 11.076z"
          fill="#EAEEF9"
        />
        <path
          d="M105.71 27.077c1.346 14.5 2.02 17.816-1.03 30.942-.991 2.92-1.982 6.116-4.107 8.344-2.974 3.47-8.357 4.996-12.747 3.887-4.533-1.11-8.215-5.006-9.065-9.728-.708-2.92.284-6.39 2.833-8.2 2.691-1.67 6.515-1.252 8.782.834 2.55 2.086 3.54 5.28 3.398 8.343-.141 3.053-1.274 6.115-2.832 8.75-3.522 6.492-4.972 6.472-12.181 17.136"
          stroke="#ABB5CC"
          strokeWidth="3.03"
          strokeDasharray="6.059"
        />
        <path
          d="M114.133 20.221c-.54 1.853-2.702 2.523-4.864 1.349-2.342-1.01-3.963-1.854-3.604-3.532.541-1.679 2.703-1.844 5.225-2.009 3.063-.34 3.603 2.348 3.243 4.192zM96.188 22.901c.902 1.476 3.43 2.46 5.234.984 1.985-1.636 3.609-2.781 2.707-4.418-.903-1.476-2.346-.984-5.415-.653-2.526.492-3.61 2.45-2.526 4.087z"
          fill="#DAE2EB"
        />
        <path
          d="M103.864 16.025c1.131-.167 2.264.512 2.588 1.534.161.334.323.846.323 1.19.323 2.379-.485 4.424-1.78 4.591-1.455.344-2.91-1.357-3.072-3.569v-1.534c.162-1.19.808-2.045 1.94-2.212.162 0 0 0 0 0z"
          fill="#989FB0"
        />
      </g>
    </svg>
  );
};

EmptyItem.displayName = 'EmptyItem';
